import script from "./SuccessOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessOverlay.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/modules/SuccessOverlay.css?vue&type=style&index=0&id=0389f30d&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0389f30d"]])

export default __exports__